import Header from "../components/header";
import AccountDetail from "../components/AccountDetails";
import Sidebar from "../components/sidebar";
import {Landmark } from "lucide-react";


const AccountDetailsPage = () => {
  return (
    <div>
        <Header 
        title="Customer"
            icon={<Landmark className="w-5 h-5" />}
        />
        <Sidebar />
      <AccountDetail />
    </div>
  );
};
export default AccountDetailsPage;